import { Editor } from '@tiptap/react';
import classNames from 'classnames';

interface BubbleMenuProps {
    editor: Editor;
}

const BubbleMenu = ({ editor }: BubbleMenuProps) => {
    const MenuButton = ({ onClick, active, icon, title }: any) => (
        <div
            onClick={onClick}
            className={classNames(
                'relative p-2 rounded-md transition-all duration-200',
                'text-content-500/80 dark:text-content-400/80',
                'hover:bg-content-100/50 dark:hover:bg-content-800/50',
                'hover:text-content-500 dark:hover:text-content-400',
                active && 'bg-content-100 dark:bg-content-800 text-content-500 dark:text-content-400'
            )}
            title={title}
        >
            <div className={classNames(icon, 'h-3.5 w-3.5')} />
        </div>
    );

    return (
        <div className="flex items-center gap-1 rounded-lg border border-content-100 dark:border-content-800 bg-base-200/95 dark:bg-content-600/95 p-1.5 shadow-lg backdrop-blur-sm">
            <MenuButton
                onClick={() => editor.chain().focus().toggleBold().run()}
                active={editor.isActive('bold')}
                icon="icon-[ph--text-b]"
                title="Bold"
            />
            <MenuButton
                onClick={() => editor.chain().focus().toggleItalic().run()}
                active={editor.isActive('italic')}
                icon="icon-[ph--text-italic]"
                title="Italic"
            />
            <MenuButton
                onClick={() => editor.chain().focus().toggleStrike().run()}
                active={editor.isActive('strike')}
                icon="icon-[ph--text-strikethrough]"
                title="Strike"
            />
            <MenuButton
                onClick={() => editor.chain().focus().toggleCode().run()}
                active={editor.isActive('code')}
                icon="icon-[ph--code]"
                title="Code"
            />
            <MenuButton
                onClick={() => {
                    const url = window.prompt('URL');
                    if (url) {
                        editor.chain().focus().setLink({ href: url }).run();
                    }
                }}
                active={editor.isActive('link')}
                icon="icon-[ph--link]"
                title="Add Link"
            />
        </div>
    );
};

export default BubbleMenu; 